import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Route } from '../../route';

export function registerProviderManagement(): void {

  const modules = [
    {
      entry: 'documents',
      id: 'documents',
      name: 'provider.documentation',
      route: Route.DOCUMENTS,
      closeable: true,
    },
    {
      entry: 'contracts',
      id: 'contracts',
      name: 'provider.search-contracts',
      route: Route.CONTRACTS,
      closeable: true,
    },
    {
      entry: 'meeting-minute-consultation',
      id: 'meeting-minute-consultation',
      name: 'provider.meeting-minute-consultation',
      route: Route.MEETING_MINUTES_CONSULTATION,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'document-management',
    id: 'document-management',
    name: 'provider.document-management',
    modules,
    order: 5,
    closeable: true,
  });
}
